<main class="wrapped-public">
  <div class="state" *ngIf="loading">Loading wrapped...</div>
  <div class="state" *ngIf="!loading && error">{{ error }}</div>

  <section
    class="experience"
    [class.intro-active]="introPlaying"
    [ngClass]="'slide-theme-' + currentSlide"
    *ngIf="!loading && !error && snapshot"
  >
    <div class="slide-atmosphere" aria-hidden="true">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>

    <div class="intro-screen" *ngIf="introPlaying" aria-live="polite">
      <div class="intro-orbit">
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div class="intro-envelope">
        <div class="intro-flap"></div>
        <div class="intro-card">
          <img
            *ngIf="snapshot.merchantLogo"
            [src]="snapshot.merchantLogo"
            [alt]="snapshot.merchantName"
          />
          <strong *ngIf="!snapshot.merchantLogo">{{
            snapshot.merchantName
          }}</strong>
        </div>
      </div>

      <div class="intro-copy">
        <img src="../assets/remylogo.png" alt="Remy" />
        <p>{{ snapshot.merchantName }} Wrapped</p>
      </div>

      <div class="intro-progress"></div>
    </div>

    <div class="brand-row">
      <img src="../assets/remylogo.png" alt="Remy" />
      <span>{{ snapshot.periodLabel }}</span>
    </div>

    <div class="stage" [class.back]="transitionDirection === 'back'">
      <div
        class="envelope"
        [class.open]="envelopeOpen"
        [ngClass]="cardFlightClass"
      >
        <div class="flap"></div>
        <div class="letter">
          <img
            *ngIf="snapshot.merchantLogo"
            [src]="snapshot.merchantLogo"
            [alt]="snapshot.merchantName"
          />
          <span *ngIf="!snapshot.merchantLogo">{{
            snapshot.merchantName
          }}</span>
        </div>
      </div>

      <ng-container
        *ngFor="let slide of slides; let i = index; trackBy: trackBySlideIndex"
      >
        <article
          class="slide"
          [class.reverse]="transitionDirection === 'back'"
          *ngIf="i === currentSlide"
        >
          <p class="eyebrow">{{ slide.eyebrow }}</p>
          <h1>{{ slide.title }}</h1>
          <p
            class="metric"
            [class.text-metric]="slide.textMetric"
            *ngIf="slide.metric"
          >
            {{ slide.metric }}
          </p>
          <p class="detail">{{ slide.detail }}</p>
        </article>
      </ng-container>
    </div>

    <div
      class="progress"
      *ngIf="!introPlaying"
      [style.gridTemplateColumns]="'repeat(' + slides.length + ', 1fr)'"
    >
      <span
        *ngFor="let slide of slides; let i = index; trackBy: trackBySlideIndex"
        [class.active]="i === currentSlide"
      ></span>
    </div>

    <nav
      class="controls"
      [class.final-controls]="currentSlide === slides.length - 1"
      *ngIf="!introPlaying"
    >
      <button
        type="button"
        (click)="previous()"
        *ngIf="currentSlide < slides.length - 1"
        [disabled]="currentSlide === 0"
        aria-label="Previous"
      >
        <mat-icon>arrow_back</mat-icon>
      </button>
      <button
        type="button"
        (click)="replay()"
        *ngIf="currentSlide === slides.length - 1"
        aria-label="Replay"
      >
        <mat-icon>replay</mat-icon>
        <span>Restart</span>
      </button>
      <button
        type="button"
        (click)="next()"
        *ngIf="currentSlide < slides.length - 1"
        aria-label="Next"
      >
        <mat-icon>arrow_forward</mat-icon>
      </button>
      <button
        type="button"
        (click)="share()"
        *ngIf="currentSlide === slides.length - 1"
        aria-label="Share"
      >
        <mat-icon>ios_share</mat-icon>
        <span>Share</span>
      </button>
    </nav>
  </section>
</main>
